/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    Device,
    ResponseReason,
} from './';

/**
 * @export
 * @interface ResponseDevicesWithTotal
 */
export interface ResponseDevicesWithTotal {
    /**
     * @type {Array<Device>}
     * @memberof ResponseDevicesWithTotal
     */
    data: Array<Device>;
    /**
     * @type {number}
     * @memberof ResponseDevicesWithTotal
     */
    total: number;
    /**
     * @type {ResponseReason}
     * @memberof ResponseDevicesWithTotal
     */
    reason: ResponseReason;
    /**
     * @type {string}
     * @memberof ResponseDevicesWithTotal
     */
    message: string;
}
